/**
 * Entry application component used to compose providers and render Routes.
 * */

import React from "react";
import { BrowserRouter } from "react-router-dom";
import { Routess } from "../app/Routes";
import { I18nProvider } from "../_metronic/i18n";
import { LayoutSplashScreen, MaterialThemeProvider } from "../_metronic/layout";
import { ToastContainer } from "react-toastify";
import { NotificationProvider } from "../_metronic/layout/components/subheader/notificationContext/NotificationContext";
import { createSignalRContext } from "react-signalr";
import { HttpTransportType } from "@microsoft/signalr";
import { LocalStorageService } from "./base/services/local-storage.service";
import { useNotificationStore } from "../_metronic/layout/components/subheader/components/useNotificationStore";
import AuthService from "./base/services/authentication.service";
import { useGlobalLoader } from "./base/utils/globalRefreshLoader";
import { Spin } from "antd";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";

const SignalRContext = createSignalRContext();
const url = process.env.REACT_APP_SIGNALR;

export default function App({ store, persistor }) {
   const { globalLoader } = useGlobalLoader()
   const { setNewNotification } = useNotificationStore();

   SignalRContext.useSignalREffect("ReceiveMessage", (data) => {
      if (data?.userId === LocalStorageService.getItem('user')?.id) {
         setNewNotification(data);
      }
   });

   return (
      <SignalRContext.Provider
         connectEnabled={true}
         accessTokenFactory={() => AuthService.getAccessToken()}
         url={url}
         skipNegotiation={true}
         transport={HttpTransportType.WebSockets}
      >
         <GoogleReCaptchaProvider
            reCaptchaKey="6LdGHpsrAAAAAI_kopYit44XyWmscMRRPyaGnNYP"
         >
            <React.Suspense fallback={<LayoutSplashScreen />}>
               {/* Override `basename` (e.g: `homepage` in `package.json`) */}
               <BrowserRouter>
                  <NotificationProvider>
                     {/*This library only returns the location that has been active before the recent location change in the current window lifetime.*/}
                     <MaterialThemeProvider>
                        {/* Provide `react-intl` context synchronized with Redux state.  */}
                        <I18nProvider>
                           {/* Render routes with provided `Layout`. */}
                           {
                              globalLoader ?
                                 <Spin
                                    style={{
                                       backgroundColor: '#f2f3f8',
                                       width: '100%',
                                       height: '100vh',
                                       justifyContent: 'center',
                                       alignItems: 'center',
                                       display: 'flex'
                                    }}>
                                 </Spin> :
                                 <Routess />
                           }
                           <ToastContainer
                              position="top-right"
                              autoClose={5000}
                              hideProgressBar={false}
                              newestOnTop={false}
                              closeOnClick
                              rtl={false}
                              pauseOnFocusLoss
                              draggable
                              pauseOnHover
                           />
                           {/* Same as */}
                           <ToastContainer />
                        </I18nProvider>
                     </MaterialThemeProvider>
                  </NotificationProvider>
               </BrowserRouter>
            </React.Suspense>
         </GoogleReCaptchaProvider>
      </SignalRContext.Provider>
   );
}
